import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '生产环境',
  environment: 'production',
  apiSrc: 'https://saas-api.neutonhealth.com',
  questionarySrc: 'https://que-design-lite.neutonhealth.com',
};
